import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useImageSourceStore = defineStore('imageSource', () => {
  const imageSource = ref(localStorage.getItem('preferredImageSource') || 'unsplash');

  function setImageSource(source) {
    imageSource.value = source;
    localStorage.setItem('preferredImageSource', source);
  }

  return {
    imageSource,
    setImageSource
  };
}); 